<template>
  <div>
    <!-- <div>{{JSON.stringify(specialityModel)}}</div> -->
    <!-- <div>{{JSON.stringify(areaModel)}}</div> -->
    <!-- <div>{{JSON.stringify(info2Model)}}</div> -->
    <customFormCommonSpeciality v-model="specialityModel" @refresh="send"></customFormCommonSpeciality>
    <customFormCommonArea v-model="areaModel" @refresh="send"></customFormCommonArea>
    <customFormCommonInfo2 v-model="info2Model" @refresh="send"></customFormCommonInfo2>
  </div>
</template>

<script>
import customFormCommonArea from "@/components/customForm/common/custom-form-common-area/custom-form-common-area.vue";
import customFormCommonCategory from "@/components/customForm/common/custom-form-common-category/custom-form-common-category.vue";
import customFormCommonSpeciality from "@/components/customForm/common/custom-form-common-speciality/custom-form-common-speciality.vue";
import customFormCommonInfo2 from "@/components/customForm/common/custom-form-common-info2/custom-form-common-info2.vue";
import { mapGetters } from "vuex";
export default {
  // 领域类别： 服务商
  name: "custom-form-service",
  props: {
    field: {
      type: Object,
      default: { extend: [], properties: [] }
    }
  },
  data() {
    return {
      propertyArr: [
        { List: [], TypeId: 0, Value: "授权渠道" },
        { List: [], TypeId: 1, Value: "招募地区" },
        { List: [], TypeId: 2, Value: "服务范围" },
        { List: [], TypeId: 3, Value: "代工品类" },
        { List: [], TypeId: 4, Value: "擅长内容" },
        { List: [], TypeId: 5, Value: "合作渠道" },
        { List: [], TypeId: 6, Value: "放大" },
        { List: [], TypeId: 11, Value: "合作客户" }
      ],
      areaModel: { List: [], TypeId: 1, Value: "招募地区" },
      specialityModel: { List: [], TypeId: 4, Value: "擅长内容" },
      info2Model: { List: [], TypeId: 6 }
    };
  },
  components: {
    customFormCommonArea,
    customFormCommonSpeciality,
    customFormCommonInfo2
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    })
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let data = this.field.properties;
      let extend = this.field.extend;
      if (!data) return;
      data.forEach(c => {
        if (c.TypeId === 1) {
          this.areaModel.List = c.List;
        }
        if (c.TypeId === 4) {
          this.specialityModel.List = c.List;
        } 
      });
      if (!extend) return;
      extend.forEach(c => {
        if (c.TypeId === 6) {
          this.info2Model.List = c.List;
        }
      }); 
    },
    send() {
      let model = [];
      let extend = null;
      if (this.specialityModel && this.specialityModel.List.length) {
        model.push(this.specialityModel);
      }
      if (this.areaModel && this.areaModel.List.length) {
        model.push(this.areaModel);
      }
      if (this.info2Model && this.info2Model.List.length) {
        extend = this.info2Model;
      } 
      this.$emit("change", { extend: [extend], properties: model });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
